export default __webpack_public_path__ + "static/media/logo-inner.a800b3c6.png";